import type { FC } from "preact/compat";
import type { CheckboxProps } from "./interfaces";
import CheckIcon from "@material-design-icons/svg/outlined/check.svg";
import cn from "classnames";

const Checkbox: FC<CheckboxProps> = ({
    className,
    label,
    checked,
    ...rest
}) => (
    <label
        className={cn(
            "flex items-start rounded-md leading-5",
            "focus-within:ring focus-within:ring-sky-500 focus-within:ring-offset-2 focus-within:ring-offset-white",
            !rest.disabled && "cursor-pointer",
            className && String(className),
        )}
    >
        <input
            {...rest}
            checked={checked}
            type="checkbox"
            className="peer h-0 w-0 opacity-0"
        />
        <span
            className={cn(
                "flex size-5 min-w-5 items-center justify-center rounded border transition-colors duration-100",
                label && "mr-2",
                checked ? "border-sky-500 bg-sky-500" : "border-gray-300",
            )}
        >
            {checked && (
                <CheckIcon width="16" height="16" className="fill-white" />
            )}
        </span>
        {label && <span>{label}</span>}
    </label>
);

export default Checkbox;
